import { canAccessClientKpi } from "../Data/legacyNavItemGate";
import { getKpiNavDisabledReasonText } from "../Data/legacyNavMessages";
import { useAppSelector } from "../Redux/Store/Store";
import {
  getClient,
  getIsClientAdmin,
  getLegacyBlazorNavVisibility,
} from "../Redux/Store/Slices/client";

/** Client-level KPI access from bootstrap `legacyBlazorNav` (matches navbar drawer KPI link). */
export function useClientKpiAccess() {
  const legacyBlazorNav = useAppSelector(getLegacyBlazorNavVisibility);
  const isClientAdmin = useAppSelector(getIsClientAdmin);
  const client = useAppSelector(getClient);

  const canAccess = canAccessClientKpi(legacyBlazorNav, isClientAdmin);
  const disabledReason = getKpiNavDisabledReasonText(legacyBlazorNav, client?.name);

  return { canAccessClientKpi: canAccess, kpiDisabledReason: disabledReason };
}
